import { Button, FormControl, IconButton, makeStyles } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import { max } from 'lodash'
import React, { useMemo } from 'react'

import { AreaLabelResponse } from 'src/api/gen'
import { getTranslation } from 'src/commons/i18n'
import NumericInput from 'src/components/Input/NumericInput'
import { SelectBox } from 'src/components/Select'

interface IProrationAreasContentProps {
  areas: AreaLabelResponse[]
  disabled?: boolean | undefined
  prorationAreasMapping: [string, number][]
  setProrationAreasMapping: React.Dispatch<React.SetStateAction<[string, number][]>>
}

const useStyles = makeStyles(() => ({
  select: {
    marginTop: 0,
  },
}))

export const ProrationAreasContent = function (props: IProrationAreasContentProps) {
  const { t } = getTranslation()
  const classes = useStyles()

  const MAX_SELECT_SIZE = 50
  const maxAreaLabelSize = useMemo(
    () =>
      Math.min(
        (max(props.areas.map((areaLabelResponse: AreaLabelResponse) => areaLabelResponse.label.length))! * 3) / 4,
        MAX_SELECT_SIZE
      ),
    [props.areas]
  )

  return (
    <>
      {props.prorationAreasMapping.map(([id, proration], index) => (
        <div
          style={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}
          key={index}
          data-testid="proration-areas-content"
        >
          {!props.disabled && (
            <FormControl>
              <IconButton
                onClick={() => {
                  props.prorationAreasMapping.splice(index, 1)
                  props.setProrationAreasMapping([...props.prorationAreasMapping])
                }}
                size="medium"
              >
                <ClearIcon />
              </IconButton>
            </FormControl>
          )}
          <FormControl
            style={{ width: props.areas.length > 1 ? `${maxAreaLabelSize}em` : undefined, margin: '0 10px' }}
          >
            <SelectBox
              disabled={props.disabled}
              value={id}
              onChange={(newArea: string) => {
                props.prorationAreasMapping[index] = [newArea, 0]
                props.setProrationAreasMapping([...props.prorationAreasMapping])
              }}
              data={props.areas}
              classes={{ select: classes.select }}
            />
          </FormControl>
          <FormControl>
            <NumericInput
              disabled={props.disabled}
              value={proration}
              onChange={(value: number) => {
                props.prorationAreasMapping[index][1] = value
                props.setProrationAreasMapping([...props.prorationAreasMapping])
              }}
              currency={'%'}
              min={0}
              max={100}
            />
          </FormControl>
        </div>
      ))}
      {!props.disabled && (
        <FormControl>
          <Button
            onClick={() => props.setProrationAreasMapping([...props.prorationAreasMapping, ['', 0]])}
            variant="outlined"
            style={{ width: 'fit-content', marginTop: '8px' }}
            size="large"
            disabled={props.areas.length === props.prorationAreasMapping.length}
          >
            {t('buttons.add.proration')}
          </Button>
        </FormControl>
      )}
    </>
  )
}
